<div class="py-2 px-2 py-md-5 px-md-5">
    <div *ngIf="isLoading; else content">
        <div class="d-flex justify-content-center mt-5">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #content>
        <div class="row">
            <div class="col-md-6">
                <mat-card class="bg-white mat-elevation-z3">
                    <div class="d-flex flex-row-reverse link-secondary mx-2 mt-2" (click)="back()"
                         style="cursor: pointer" (keydown.backspace)="back()" role="button" aria-hidden="true">
                        <mat-icon aria-hidden="false" matTooltip="Zamknij" matTooltipPosition="below">close</mat-icon>
                    </div>
                    <div class="col-9 header">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-icon class="mx-1" color="primary">task</mat-icon>
                                Zadanie
                            </mat-card-title>
                            <mat-card-subtitle>Szczegółowe informacje na temat zadania.</mat-card-subtitle>
                        </mat-card-header>
                    </div>
                    <mat-card-content>
                        <div class="pt-4">
                            <ul class="no-bullets">
                                <li><h5>Data utworzenia: <b
                                    class="text-primary-color">{{ task.created_at | date: 'dd.MM.yyyy' }}</b></h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li>
                                    <h5>Priorytet:
                                        <b>
                                            <app-task-priority-color
                                                [taskPriority]="task.priority"></app-task-priority-color>
                                        </b>
                                        <button *ngIf="!task.completed" class="mx-2" mat-stroked-button
                                                matTooltip="Status"
                                                (click)="changeTaskStatus(task.id, task.priority, task.status)"
                                                matTooltipPosition="above" aria-label="Status">
                                            Zmień
                                            <mat-icon>change_circle</mat-icon>
                                        </button>
                                    </h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>Nazwa: <b
                                    class="text-primary-color">{{ task.name }}</b></h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>Opis: <b
                                    class="text-primary-color">{{ task.description }}</b></h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li>
                                    <h5>Status:
                                        <b>
                                            <app-task-status-color [taskStatus]="task.status"></app-task-status-color>
                                        </b>
                                        <button *ngIf="!task.completed" class="mx-2" mat-stroked-button
                                                matTooltip="Status"
                                                (click)="changeTaskStatus(task.id, task.priority, task.status)"
                                                matTooltipPosition="above" aria-label="Status">
                                            Zmień
                                            <mat-icon>change_circle</mat-icon>
                                        </button>
                                    </h5>
                                </li>
                            </ul>
                            <ul *ngIf="task.deadline" class="no-bullets">
                                <li><h5>Termin wykonania: <b
                                    class="text-primary-color">{{ task.deadline | date: 'dd.MM.yyyy' }}</b></h5>
                                </li>
                            </ul>
                            <ul *ngIf="task.comment" class="no-bullets">
                                <li><h5>Termin wykonania: <b
                                    class="text-primary-color">{{ task.comment }}</b></h5>
                                </li>
                            </ul>
                            <div *ngIf="task.completed" class="pt-2 text-center">
                                <h5 class="text-success"><i class="fa-solid fa-car-side text-success"></i> Archiwalne
                                </h5>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div class="col-md-6 text-center py-5">
            <button mat-stroked-button (click)="back()">
                <i class="fa-solid fa-rotate-left"></i> Zamknij
            </button>
            <button *ngIf="!task.completed" class="mx-2" mat-stroked-button (click)="editTask()"><i
                class="fa-solid fa-pen-to-square"></i>
                Edytuj
            </button>
            <button *ngIf="authService.user.type === 'admin' && !task.completed" mat-stroked-button
                    color="warn" (click)="completed()"><i
                class="fa-solid fa-check"></i>
                Zakończ
            </button>
        </div>
    </ng-template>
</div>
